import { render, staticRenderFns } from "./CommercialLeadsTable.vue?vue&type=template&id=9d2e5200&"
import script from "./CommercialLeadsTable.vue?vue&type=script&lang=js&"
export * from "./CommercialLeadsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports